import createDOMNode from './createDOMNode';

export default function getDOMNode(nodes, baseNode, type) {
  var media = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var support = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var key = type + media + (support ? 'support' : '');

  if (!nodes.hasOwnProperty(key)) {
    nodes[key] = createDOMNode(type, baseNode, media, support);
  }

  return nodes[key];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/getDOMNode.js
// module id = 38
// module chunks = 0